/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { Box, Link } from '@bottlebooks/gatsby-theme-base';
import useSiteConfig from '@bottlebooks/gatsby-theme-event/src/components/useSiteConfig';
import useLink from '@bottlebooks/gatsby-theme-event/src/useLink';
import { Trans } from '@lingui/macro';
import { jsx } from 'theme-ui';

export default function PersonalMenu(props) {
  const config = useSiteConfig();
  const link = useLink();
  return (
    <Box {...props}>
      <MenuItem to={link.favorites()}>
        <Trans>My Favorites</Trans>
      </MenuItem>
      {config.listsEnabled && (
        <MenuItem to={link.tastingList()}>
          <Trans>My Tasting List</Trans>
        </MenuItem>
      )}
      {config.tastingNotesEnabled && (
        <MenuItem to={link.tastingNotes()}>
          <Trans>My Tasting Notes</Trans>
        </MenuItem>
      )}
    </Box>
  );
}
function MenuItem({ children, to, ...rest }) {
  return (
    <Link
      to={to}
      sx={{
        variant: 'text.default',
        display: 'inline-block',
        paddingY: 2,
        paddingX: 3,
        borderBottom: 2,
        borderBottomColor: 'transparent',
        color: 'lightText',
        '&.bb-active': { borderBottomColor: 'primary', color: 'primary' },
        '&.bb-active:hover': { borderBottomColor: 'secondary' },
      }}
      activeClassName="bb-active"
      partiallyActive
      {...rest}
    >
      {children}
    </Link>
  );
}
